import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import State from './state';

const getters: GetterTree<State, RootState> = {
    isTargetGrouping(state: State) {
        const operators = Object.values(state.operators);
        return operators.filter( (operator) => operator.isGroupingTarget === true );
    },
};

export default getters;
